import React, { createContext, useState, useEffect, useContext } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [cartCount, setCartCount] = useState(0);

  // Load cart from localStorage on initial render
  useEffect(() => {
    const savedCart = localStorage.getItem('cart');
    if (savedCart) {
      try {
        const parsedCart = JSON.parse(savedCart);
        setCartItems(parsedCart);
        updateCartCount(parsedCart);
      } catch (error) {
        console.error('Error parsing cart from localStorage:', error);
      }
    }
  }, []);

  // Update cart count whenever cartItems changes
  const updateCartCount = (items) => {
    const count = items.length;
    setCartCount(count);
  };

  // Check if item is in cart
  const isInCart = (itemId) => {
    return cartItems.some(item => item.id === itemId);
  };

  // Add item to cart
  const addToCart = (item) => {
    // If item already exists, don't add it again
    if (isInCart(item.id)) return;
    
    setCartItems(prevItems => {
      // Add new item with quantity 1
      const newItems = [...prevItems, { ...item, quantity: 1 }];
      
      // Save to localStorage and update count
      localStorage.setItem('cart', JSON.stringify(newItems));
      updateCartCount(newItems);
      return newItems;
    });
  };

  // Remove item from cart
  const removeFromCart = (itemId) => {
    setCartItems(prevItems => {
      const newItems = prevItems.filter(item => item.id !== itemId);
      
      localStorage.setItem('cart', JSON.stringify(newItems));
      updateCartCount(newItems);
      return newItems;
    });
  };

  // Clear cart
  const clearCart = () => {
    setCartItems([]);
    setCartCount(0);
    localStorage.removeItem('cart');
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        cartCount,
        addToCart,
        removeFromCart,
        clearCart,
        isInCart
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartContext; 